import React from "react";
import "./Podcasts.css";

import environment from "../../../RelayEnvironment";
import { graphql, QueryRenderer } from "react-relay";
import Podcasts from "./Podcasts";

const GET_PODCASTS = graphql`
  query PodcastsPageQuery {
    whoAmI {
      groups {
        name
      }
    }

    podcasts {
      id
      title
      downloadUrl
      description
      prettyPubDate
      durationSeconds
      prettyDuration
      series {
        id
        title
        coverPhoto
      }
    }
  }
`;

export default function PodcastsPage() {
  return (
    <QueryRenderer
      environment={environment}
      query={GET_PODCASTS}
      variables={{}}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return <></>;
        }

        let isAdmin = false;

        if (props.whoAmI) {
          isAdmin =
            props.whoAmI.groups.find((group) => group.name === "Site Admin") !==
            undefined;
        }

        return <Podcasts podcasts={props.podcasts} isAdmin={isAdmin} />;
      }}
    />
  );
}
